<template>
  <div class="">
    <div class="row">
      <div class="col-6">
        <div class="row">
          <q-card class="city col-12">
            <q-card-section>
              <div class="row">
                <div class="col-md-5">
                  <div class="titleCard">Municipio</div>
                  <div class="row input">
                    <q-input
                      data-cy="nameCity"
                      outlined
                      v-model="datosCiudadName"
                      label="Municipio"
                      class="col-md-12"
                      @input="edited()"
                      :error="$v.datosCiudadName.$error"
                    >
                      <template v-slot:error>Dato obligatorio.</template>
                    </q-input>
                  </div>
                  <div class="row toggle">
                    <q-toggle
                      v-model="datosCiudadEstado"
                      :label="
                        datosCiudadEstado
                          ? 'Visible en listado'
                          : 'No visible en el listado'
                      "
                      @input="edited()"
                      data-cy="toggle-ciudad-visible"
                    />
                  </div>
                </div>
                <div class="col-md-4 uploadFondo">
                  <UploadImage
                    @input="edited()"
                    @deleteImg='deleteImgFondo()'
                    style="float:right"
                    data-cy="uploadImg"
                    label="CAMBIAR FONDO"
                    labelBorrar="BORRAR FONDO"
                    v-model="datosCiudadImgFondo"
                    :botonDelete="true"
                    :showPreview="{
                      show: true,
                      sizes: {
                        width: '97px',
                        height: '97px'
                      },
                      ratio: 16 / 9
                    }"
                  />
                </div>
                <div class="col-md-3 uploadLogo">
                  <UploadImage
                    @input="edited()"
                    @deleteImg='deleteImgLogo()'
                    style="float:right"
                    label="CAMBIAR LOGO"
                    labelBorrar="BORRAR LOGO"
                    v-model="datosCiudadImgLogo"
                    :botonDelete="true"
                    :showPreview="{
                      show: true,
                      sizes: {
                        width: '97px',
                        height: '97px'
                      },
                      ratio: 16 / 9
                    }"
                  />
                </div>
              </div>
            </q-card-section>
          </q-card>
          <q-card class='GUD col-12'>
            <q-card-section>
              <div class="titleCard">
                Usuario y contraseña API Green urban data
              </div>
              <DetalleProveedor
              :proveedor="{usuarioProveedor: usuarioProveedor, claveProveedor: claveProveedor, codigoINEProvincia: codigoINEProvincia, codigoINEMunicipio: codigoINEMunicipio }"
              @dataUserProveedor='updateDataProveedor($event)'/>
            </q-card-section>
          </q-card>
        </div>
      </div>
      <div class="col-6">
        <q-card class='usuarios'>
          <q-card-section>
            <div class="titleCard">Lista de usuarios</div>
            <div class="row">
              <div class="col-md-12 dBtn">
                <q-btn
                  data-cy="Add-user"
                  unelevated
                  class="bSecondary"
                  label="AÑADIR USUARIO"
                  @click="triggerAdd()"
                />
              </div>
            </div>
            <ListadoUsuarios
              :dataUsuarios="usuarios"
              :isLoading="isLoadingUsuarios"
            />
          </q-card-section>
        </q-card>
      </div>
      <div class="col-12 dLast">
        <div class="row" style="align-items:center;">
          <q-card class="col-md-12 row">
          <div class="col-12 titleCard">Índices del Municipio</div>
            <div
              class="box-container col-6 col-md-4"
              v-for="item in indices"
              v-bind:key="item.id"
            >
              <ContenedorIndiceCiudad
                :datos="item"
                :datosEnabled="isInArrayIndicesCiudad(item.id)"
              />
            </div>
          </q-card>
        </div>
      </div>
      <div class="col-12 dLast titleCard">
        <ListadoIndices
          title="Índices temáticos"
          titleclass="titleCardEdicion"
          :indicesTematicosCiudad="indicesTematicosCiudad"
          :isLoading="isLoadingIndices"
          :visibleColumns="visibleColumns"
          :selectionFormat="'multiple'"
          @refreshIndicadores="refreshIndicadores"
        />
      </div>

      <div class="col-12 dLast">
        <ListadoIndicadores
          title="Indicadores"
          titleclass="titleCardEdicion"
          :indicadoresCiudad="indicadoresCiudadContratados"
          :indicadoresIndiceTematico="indicadoresIndiceTematico"
          :isLoading="isLoadingIndicadores"
          :selectionFormat="'multiple'"
        />
      </div>
    </div>

    <DialogCreate
      v-model="showDialogAddUser"
      title="Añadir a nuevo usuario"
      labelSuccess="Añadir"
      dataCy="create-user"
      @save="addUser()"
    >
      <template slot="body">
        <div class="title-option text-center">
          Añada a un nuevo usuario buscándolo por apellidos y nombre o email
        </div>
        <div class="row q-col-gutter-md col-12">
          <div class="col-12">
            <SelectSearchBox
              placeholder="Nombre y apellidos"
              hint="Introduzca al menos 3 caracteres"
              optionValue="nombre"
              nameCypress="user-name"
              noOption="Sin resultados"
              :showNoOption="selectSearchBox.haveError ? false : true"
              :optionsSelect="selectSearchBox.userList"
              v-model="selectSearchBox.userSelected"
              @filterEvent="filterFnUsuarios"
              :isSearching="selectSearchBox.isSearching"
            />
          </div>
          <div class="col-12 text-center text-negative">
            {{ selectSearchBox.haveError ? selectSearchBox.haveError : '' }}
          </div>
        </div>
      </template>
    </DialogCreate>
  </div>
</template>
<script>
import { QCard, QCardSection, QToggle } from 'quasar';
import UploadImage from '@/shared/uploadImage/components/UploadImage.vue';
import ListadoUsuarios from '../components/ListadoUsuarios.vue';
import ListadoIndices from '@/components/IndicesTematicos/components/ListadoIndices.vue';
import * as types from '@/storeModules/NGUD/types';
import Loading from '@/components/shared/mixins/Loading.js';
import ContenedorIndiceCiudad from '@/components/Ciudades/components/ContenedorIndiceCiudad.vue';
import { required } from 'vuelidate/lib/validators';
import Validation from '@/components/shared/mixins/Validation.js';
import { mapGetters } from 'vuex';
import SelectSearchBox from '@/shared/select-apisearch/components/Select.vue';
import DialogCreate from '@/shared/dialogs/create/DialogCreate.vue';
import Utils from '@/components/shared/helpers/Utils.js';
import Resources from '@/components/shared/mixins/Resources.js';
import DetalleProveedor from './DetalleProveedor.vue';
import ListadoIndicadores from '../components/ListadoIndicadores.vue';

export default {
  components: {
    QCard,
    QCardSection,
    QToggle,
    UploadImage,
    ListadoUsuarios,
    ListadoIndices,
    ContenedorIndiceCiudad,
    SelectSearchBox,
    DialogCreate,
    DetalleProveedor,
    ListadoIndicadores
  },
  mixins: [Validation, Loading, Resources],
  validations: {
    datosCiudadName: { required }
  },
  props: {
    ciudad: Object,
    indices: Array,
    indicesCiudad: Array,
    indicesTematicos: Array,
    indicesTematicosCiudad: Array,
    indicadoresCiudad: Array
  },
  computed: {
    ...mapGetters({
      ciudadSelected: 'NGUD/ciudadData',
      usuarios: types.ALL_USUARIOS
    })
  },
  data () {
    return {
      indicadoresIndiceTematico: [],
      currentArrayIndicadores: [],
      indicadoresCiudadContratados: [],
      initialArrayUsers: [],
      pasaPorCreate: false,
      value: true,
      datosCiudadImgFondo: null,
      datosCiudadImgLogo: null,
      datosCiudadName: '',
      datosCiudadEstado: false,
      usuarioProveedor: '',
      claveProveedor: '',
      codigoINEProvincia: '',
      codigoINEMunicipio: '',
      isLoadingIndices: false,
      isLoadingIndicadores: false,
      isLoadingUsuarios: false,
      visibleColumns: ['estado', 'name', 'order', 'editar'],
      showDialogAddUser: false,
      selectSearchBox: {
        isSearching: false,
        userList: [],
        userSelected: null,
        haveError: null
      }
    };
  },
  mounted () {
    this.$eventHub.$on('saveCity', (cityItemEdited, indicesTematicosObject, indicadoresObject) => {
      this.SaveCity(cityItemEdited, indicesTematicosObject, indicadoresObject);
    });
  },
  beforeDestroy () {
    this.$eventHub.$off('saveCity');
  },
  created () {
    if (
      this.$route.params.idCiudad == null ||
      this.$route.params.idCiudad === undefined
    ) {
      this.$store.commit(types.MUTATE_ALL_USUARIOS, []);
    } else {
      // se guarda un array del estado inicial de usuarios en la edición
      this.$store
        .dispatch(types.ACTION_GET_ALL_USUARIOS, {
          idCiudad: this.$route.params.idCiudad
        })
        .then(resp => {
          this.hideLoading();
          this.initialArrayUsers = [...this.usuarios];
        })
        .catch(() => {
          this.hideLoading();
        });
    }
  },
  watch: {
    ciudad () {
      this.restoreData();
      this.indicadoresCiudadContratados = this.ciudad.indicadoresContratados;
    },
    indicesTematicosCiudad: {
      handler: function () {
        if (this.indicesTematicosCiudad && this.indicesTematicosCiudad.length > 0) {
          this.currentArrayIndicadores = [];
          this.fillArrayIndicadoresIndiceTematico(this.indicesTematicosCiudad);
        }
      }
    }

  },
  methods: {
    restoreData () {
      if (this.$route.params.idCiudad && this.ciudad) {
        this.datosCiudadName = this.ciudad.name;
        this.datosCiudadEstado = this.ciudad.estado;
        this.datosCiudadImgFondo = this.ciudad && this.ciudad.file && this.ciudad.file.length > 0 && this.searchResource(this.ciudad.file, 'imagen-fondo') ? this.searchResource(this.ciudad.file, 'imagen-fondo').url : null;
        this.datosCiudadImgLogo = this.ciudad && this.ciudad.file && this.ciudad.file.length > 0 && this.searchResource(this.ciudad.file, 'imagen-logo') ? this.searchResource(this.ciudad.file, 'imagen-logo').url : null;
        this.usuarioProveedor = this.ciudad.usuarioProveedor;
        this.claveProveedor = this.ciudad.claveProveedor;
        this.codigoINEProvincia = this.ciudad.codigoINEProvincia;
        this.codigoINEMunicipio = this.ciudad.codigoINEMunicipio;
      }
    },
    async filterFnUsuarios (textToSearch, update, abort) {
      if (textToSearch.length > 3 && !this.selectSearchBox.isSearching) {
        this.userListFiltered = [];
        this.selectSearchBox.haveError = null; // Reset Error
        this.selectSearchBox.isSearching = true;
        await this.$store
          .dispatch(types.ACTION_FILTER_USUARIOS, textToSearch)
          .then(response => {
            for (let i = 0; i < response.data.length; i++) {
              const nombreCompleto =
                response.data[i].surNames + ', ' + response.data[i].name;
              this.userListFiltered.push({
                id: response.data[i].id,
                email: response.data[i].email,
                nombre: nombreCompleto
              });
            }
            this.selectSearchBox.isSearching = false;
          })
          .catch(e => {
            this.selectSearchBox.haveError = e.message;
            this.selectSearchBox.isSearching = false;
            abort();
          });
      }

      if (textToSearch === '') {
        update(() => {
          this.selectSearchBox.userList = this.userListFiltered;
        });
      } else if (this.userListFiltered.length === 0) {
        update(() => {
          this.selectSearchBox.userList = [];
        });
      } else {
        update(() => {
          this.selectSearchBox.userList = this.userListFiltered;
        });
      }
    },
    async addUser () {
      let selectedUser = this.selectSearchBox.userSelected;

      if (!selectedUser) return;
      this.$eventHub.$emit('viewEdited');

      this.showDialogAddUser = false;

      if (!this.usuarios.find(user => user.idUsuario === selectedUser.id)) {
        var nameComplet = selectedUser.nombre;
        var split = nameComplet.split(', ');
        var surNames = split[0];
        var firstName = split[1];

        let item = {
          idCiudad: this.$route.params.idCiudad,
          idUsuario: selectedUser.id,
          name: firstName,
          surNames: surNames,
          email: selectedUser.email,
          enabled: true
        };
        this.usuarios.push(item);
        this.$store.commit(types.MUTATE_ALL_USUARIOS, this.usuarios);
      }
    },
    triggerAdd () {
      this.showDialogAddUser = true;
      this.selectSearchBox.haveError = null;
    },
    checkToSave () {
      this.$v.$touch();
      return !this.$v.datosCiudadName.$error && this.checkINEMunicipio();
    },
    checkINEMunicipio () {
      return (((this.codigoINEMunicipio === null || this.codigoINEMunicipio === '' || this.codigoINEMunicipio === undefined) || (this.codigoINEMunicipio.length === 3)) &&
      ((this.codigoINEProvincia === null || this.codigoINEProvincia === '' || this.codigoINEProvincia === undefined) || (this.codigoINEProvincia.length === 2)));
    },
    edited () {
      this.$eventHub.$emit('viewEdited');
    },
    updateDataProveedor (proveedor) {
      this.usuarioProveedor = proveedor.usuarioProveedor;
      this.claveProveedor = proveedor.claveProveedor;
      this.codigoINEProvincia = proveedor.codigoINEProvincia;
      this.codigoINEMunicipio = proveedor.codigoINEMunicipio;
      this.$eventHub.$emit('viewEdited');
    },
    prepareDataCityToSave (cityItemEdited, indicesTematicosObject, indicadoresObject) {
      const finalSelectedIndices = Array.isArray(cityItemEdited)
        ? cityItemEdited.map(indice => String(indice))
        : this.indicesCiudad.map(indice => String(indice));
      return {
        Name: this.datosCiudadName.trim(),
        Estado: this.datosCiudadEstado,
        FileFondo: this.datosCiudadImgFondo === null ? new File([''], 'filename') : this.datosCiudadImgFondo,
        FileLogo: this.datosCiudadImgLogo === null ? new File([''], 'filename') : this.datosCiudadImgLogo,
        Indices: finalSelectedIndices,
        IndicesTematicos: indicesTematicosObject.eventPassed ? indicesTematicosObject.indicesEdited : this.indicesTematicosCiudad,
        IndicadoresContratados: indicadoresObject.eventPassed ? indicadoresObject.indicadoresEdited : this.indicadoresCiudadContratados,
        usuarioProveedor: this.usuarioProveedor,
        claveProveedor: this.claveProveedor,
        codigoINEProvincia: this.codigoINEProvincia !== undefined ? this.codigoINEProvincia : '',
        codigoINEMunicipio: this.codigoINEMunicipio !== undefined ? this.codigoINEMunicipio : ''
      };
    },
    saveEditedUser (ciudad) {
      let difference = Utils.diffArray(
        this.initialArrayUsers,
        this.usuarios
      );
        // se recorre el array de diferencias
      difference.forEach(usuarioDiff => {
        // si no está en el array inicial, se añade
        if (this.initialArrayUsers.indexOf(usuarioDiff) === -1) {
          this.saveUsuario(ciudad, usuarioDiff);
        }
        // si en this.usuarios no está el item, lo borramos
        if (this.usuarios.indexOf(usuarioDiff) === -1) {
          this.deleteUsuario(usuarioDiff);
        }
      });
      this.initialArrayUsers = [...this.usuarios];
    },
    async updateCitySelected () {
      await this.$store.dispatch(types.ACTION_GET_CIUDAD, {
        idCiudad: this.$route.params.idCiudad
      }).then(responseIdCiudad => {
        this.hideLoading();
        this.$store.commit('NGUD/setCiudadSelected', responseIdCiudad.data);
      }).catch(() => {
        this.hideLoading();
      });
    },
    checkCityEditedIsCitySelected () {
      let edited = false;
      if (this.ciudadSelected.id === this.$route.params.idCiudad) {
        edited = true;
      }
      return edited;
    },
    async saveEditedCity (ciudad) {
      let modify = {
        estado: this.datosCiudadEstado,
        name: this.datosCiudadName.trim()
      };
      this.showLoading();
      await this.$store.dispatch(types.ACTION_SAVE_CIUDAD, {
        newCity: ciudad,
        idCiudad: this.$route.params.idCiudad,
        objModify: modify
      }).then(ciudadResponse => {
        this.saveEditedUser(ciudadResponse);
        if (this.checkCityEditedIsCitySelected()) this.updateCitySelected();
        this.hideLoading();
        this.$eventHub.$emit('viewSaved');
      }).catch(() => {
        this.hideLoading();
      });
    },
    async saveNewCity (ciudad) {
      this.showLoading();
      await this.$store.dispatch(types.ACTION_SAVE_NEW_CIUDAD, { newCity: ciudad }).then(ciudadResponse => {
        // guardado de usuarios
        this.usuarios.forEach(usuario => {
          this.saveUsuario(ciudadResponse, usuario);
        });
        this.hideLoading();
        this.$eventHub.$emit('viewSaved');
        this.$router.push({ name: 'ciudades' });
      }).catch(() => {
        this.hideLoading();
      });
    },
    SaveCity (cityItemEdited, indicesTematicosObject, indicadoresObject) {
      if (this.checkToSave()) {
        let ciudad = this.prepareDataCityToSave(cityItemEdited, indicesTematicosObject, indicadoresObject);
        if (this.$route.params.idCiudad) {
          this.saveEditedCity(ciudad);
        } else {
          this.saveNewCity(ciudad);
        }
      }
    },
    async saveUsuario (response, usuario) {
      await this.$store
        .dispatch(types.ACTION_SAVE_USUARIO, {
          idCiudad: response.data.id,
          idUsuario: usuario.idUsuario,
          item: usuario
        })
        .then(resp => {
          this.hideLoading();
          this.showDialogAddUser = false;
        })
        .catch(() => {
          this.hideLoading();
        });
    },
    async deleteUsuario (usuarioDiff) {
      await this.$store
        .dispatch(types.ACTION_DELETE_USUARIO, {
          idUsuario: usuarioDiff.idUsuario,
          idCiudad: this.$route.params.idCiudad,
          items: usuarioDiff
        })
        .then(response => {
          this.showDialogDelete = false;
          this.hideLoading();
        })
        .catch(() => {
          this.hideLoading();
        });
    },
    isInArrayIndicesCiudad (idItem) {
      let value = this.indicesCiudad.indexOf(idItem);
      return value !== -1;
    },
    fillArrayIndicadoresIndiceTematico (indicesTematicosSelected) {
      indicesTematicosSelected.forEach(idIndice => {
        // por cada indice tematico visible de la ciudad obtengo sus indicadores y su nombre
        this.getDataToFillTableIndicadores(idIndice).then(objectData => {
          this.addInfoIndicadorToTable(objectData.indicadores, objectData.nameIndice);
        });
      });
    },
    async getDataToFillTableIndicadores (idIndice) {
      let indiceData = await this.$store.dispatch(
        types.ACTION_GET_INDICE_TEMATICO, { idIndiceTematico: idIndice });

      let indicadoresData = await this.$store.dispatch(
        types.ACTION_GET_INDICADOR_INDICE_TEMATICO, { idIndiceTematico: idIndice });
      this.isLoadingIndicadores = false;
      return {
        nameIndice: indiceData.name,
        indicadores: indicadoresData.data
      };
    },
    addInfoIndicadorToTable (indicadores, indiceTematicoName) {
      indicadores.forEach(indicador => {
        // se comprueba si el indicador ya esta añadido a la tabla sino, lo añade
        let positionIndicador = this.checkDuplicateIndicador(indicador);
        if (positionIndicador === -1) {
          this.currentArrayIndicadores.push({
            id: indicador.id,
            estado: false,
            idProveedor: indicador.idProveedor,
            name: indicador.name,
            indiceTematico: indiceTematicoName,
            unidadMedida: indicador.unidadMedida,
            periodicidad: indicador.periodicidad
          });
          this.indicadoresIndiceTematico = this.currentArrayIndicadores;
        } else {
        // si ha encontrado duplicados, modificar el campo indice tematico en el array this.currentArrayIndicadores
          let currentNameIndice = this.currentArrayIndicadores[positionIndicador].indiceTematico;
          if (currentNameIndice.indexOf(indiceTematicoName) === -1) {
            let cadena = currentNameIndice + ', ' + indiceTematicoName;
            this.currentArrayIndicadores[positionIndicador].indiceTematico = cadena;
            this.indicadoresIndiceTematico = this.currentArrayIndicadores;
          }
        }
      });
    },
    checkDuplicateIndicador (dataIndicador) {
      return this.currentArrayIndicadores.findIndex(indicador => indicador.id === dataIndicador.id);
    },
    refreshIndicadores (indicesTematicosSeleccionados) {
      this.isLoadingIndicadores = true;
      this.currentArrayIndicadores = [];
      if (indicesTematicosSeleccionados.selected.length > 0) {
        this.fillArrayIndicadoresIndiceTematico(indicesTematicosSeleccionados.selected);
      } else {
        this.indicadoresIndiceTematico = [];
        this.isLoadingIndicadores = false;
      }
    },
    deleteImgFondo () {
      if (this.ciudad.file.length !== 0) {
        this.$eventHub.$emit('viewEdited');
        this.ciudad.fileFondo = new File([''], 'filename');
        this.datosCiudadImgFondo = null;
      }
    },
    deleteImgLogo () {
      if (this.ciudad.file.length !== 0) {
        this.$eventHub.$emit('viewEdited');
        this.ciudad.fileLogo = new File([''], 'filename');
        this.datosCiudadImgLogo = null;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.q-card-title {
  font-size: 16px;
  font-weight: bold;
  letter-spacing: 0.13px;
  color: #474848;
  margin-left: -10px;
  margin-top:-10px;
  font-family: 'DINPro';
  font-style: normal;
}
div.row > div.col-6:first-child {
  padding-right: 24px;
}
button.q-btn.imgBtn {
  margin-left: 0px !important;
  margin-right: 15px;
}
.input {
  margin-top: 27px;
}
.toggle {
  margin-top: 51px;
}
.dLast {
  margin-top: 25px;
}
.bSecondary {
  float: right;
}
.bPrincipal {
  float: right;
}
.q-card.city {
  // height: 445px !important;
  padding-bottom: 0px;
  .q-card__section {
    padding-bottom: 0px;
  }
}
.GUD{
  margin-top: 15px;
}
.usuarios{
  height: 100% !important;
}

.uploadFondo, .uploadLogo {
  display: flex;
  justify-content: center;
}

</style>
